import React, { useEffect, useState } from "react";
import * as contactApi from "../../../apis/contactApi";
import { Table, Card, CardBody, CardTitle, Row, Col, Button, Input, InputGroup } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import { PropTypes } from "prop-types";
import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import ConfirmDelete from "components/Common/ConfirmDelete";
import ConfirmRestore from "components/Common/ConfirmRestore";
import "flatpickr/dist/themes/material_blue.css"
import FooterTableItem from "components/TableItem/FooterTableItem";
import MetaTags from 'react-meta-tags';


function ListFooter(props) {
  const [deleteId, setDeleteId] = useState(null);
  const [restoreId, setRestoreId] = useState(null);
  const selectedShop = useSelector(state => state.SelectedShop);
  const [dataFooter, setDataFooter] = useState([])
  let history = useHistory();
  const showProductCatItem = () => {
    if (dataFooter) {
      if (dataFooter?.length === 0) {
        return <tr></tr>;
      } else {
        return dataFooter && dataFooter.map((v, i) => {
          return (
            <FooterTableItem
              key={i}
              data={v}
              count={i + 1}
              deleteCallback={onDelete}
              restoreCallback={setRestoreId}
            />
          );
        });
      }
    }
  };

  const onChangePage = page => {
    let url = props.location.pathname + "?page=" + page;
    history.push(url);
  };
  useEffect(() => {
    fetchData();
  }, [])
  const fetchData = page => {
    contactApi.getListFooter(fetchDataSuccess, fetchDataFail);
  };
  const fetchDataSuccess = res => {
    const { data } = res.data;
    setDataFooter(data)
  };
  const fetchDataFail = res => {
    alert("Không có dữ liệu");
  };


  const onDelete = id => {
    contactApi.deleteFooter(id, deleteSuccess, deleteFail);
  };

  const deleteSuccess = res => {
    alert("Banner đã xoá thành công");
    fetchData();
  };
  const deleteFail = res => {
    alert(res.message);
    setDeleteId(null);
  };

  return (
    <div className="page-content">
    <MetaTags>
        <title>CMS | Menu footer</title>
    </MetaTags>
      {deleteId ? (
        <ConfirmDelete
          confirmCallback={() => {
            onDelete(deleteId);
          }}
          cancelCallback={() => {
            setDeleteId(null);
          }}
        />
      ) : (
        ""
      )}
      {restoreId ? (
        <ConfirmRestore
          confirmCallback={() => {
            onRestore(restoreId);
          }}
          cancelCallback={() => {
            setRestoreId(null);
          }}
        />
      ) : (
        ""
      )}
      <Card>
        <CardBody>
          <Card color='light'>
            <CardBody>
              <Row className="justify-content-between">
                <Col xs="auto" sm="auto"><CardTitle className="h4">Danh sách Footer</CardTitle></Col>
                <Col xs="auto" sm="auto">
                  <Link to="/footer/create">
                    {" "}
                    <Button color="primary" className="px-3 rounded-pill">
                      <i className="fas fa-plus mr-2"></i> Thêm mới
                    </Button>
                  </Link>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <div className="table-responsive">
            <Table className="table mb-3 mytable">
              <thead>
                <tr>
                  <th>STT</th>
                  <th>Tên</th>
                  <th>Thứ tự hiển thị</th>
                  <th>Thao tác</th>
                </tr>
              </thead>
              <tbody>{showProductCatItem()}</tbody>
            </Table>
          </div>
          {/* <MyPagination
            startPage={dataContact.current_page ? dataContact.current_page : 1}
            totalItemsCount={dataContact.total ? dataContact.total : 5}
            callback={onChangePage}
          /> */}
        </CardBody>
      </Card>
    </div>
  );
}
ListFooter.propTypes = {
  location: PropTypes.object,
};

export default withRouter(ListFooter);
